export default "__VITE_ASSET__64c78954__"